import { Box, Tag, TagLabel, Text } from "@chakra-ui/react";
import { formatCurrencyString, formatCurrencyStringForKPI } from "../../../utils/string.utils";
import Skeleton from "react-loading-skeleton";

interface Props {
	title: string;
	count: number;
	tagContent: string;
	noteText: string;
	tagBackgroundColor?: string;
	tagTextColor?: string;
	isCurrencyValue?: boolean;
	isLoading?: boolean;
	decimalLocalizationEnabled?: boolean;
}

const StatItem = ({
	title,
	count,
	tagContent,
	noteText,
	isCurrencyValue = false,
	tagBackgroundColor = "hsl(var(--brand))",
	tagTextColor = "#FFFFFF",
	isLoading = false,
	decimalLocalizationEnabled = false,
}: Props) => {
	return (
		<Box
			boxShadow={"0px 2px 11px 0px #00000026"}
			borderRadius={"8px"}
			borderColor={"#D4D4D4"}
			w="100%"
			p={4}
			h={"160px"}
		>
			<Text fontWeight={500} fontSize={"14px"} color={"#999999"}>
				{title}
			</Text>
			{isLoading ? (
				<Skeleton className="my-4" height={100} count={1} />
			) : (
				<>
					<Text my={4} fontWeight={700} fontSize={"24px"} color={"#4F5253"}>
						{isCurrencyValue
							? formatCurrencyString(count, { maximumFractionDigits: 0 })
							: decimalLocalizationEnabled
							? formatCurrencyStringForKPI(count, { maximumFractionDigits: 0 })
							: count}
					</Text>

					<Tag borderRadius="full" variant="solid" bg={tagBackgroundColor} textColor={tagTextColor}>
						<TagLabel>{tagContent}</TagLabel>
					</Tag>
					<Text my={1} fontWeight={400} fontSize={"12px"} color={"#ACACAC"}>
						{noteText}
					</Text>
				</>
			)}
		</Box>
	);
};

export default StatItem;
